import * as React from "react";
import SolutionPageLayout from "../components/Solution/PageLayout";
import * as pageStyles from "../pages/solution/solution-page.module.css";

const styles = {
    page: pageStyles.solutionPage,
    content: pageStyles.solutionPage__content,
    faq: pageStyles.solutionPage__faq,
};

const FunctionalPageTemplate = ({pageContext: {functionalData}}) => {
    return <SolutionPageLayout data={functionalData} styles={styles} />;
};

export default FunctionalPageTemplate;
